import classnames from "classnames";
import { Link as LinkElement } from "react-router-dom";
import { Text } from "../text/Text";
import "./Link.scss";

type LinkProps = {
  className: string;
  lKey: string;
  path: string;
  isPointer?: boolean;
};

export const Link = ({ className, lKey, path, isPointer }: LinkProps) => {
  return (
    <div
      className={classnames("link-primary", className, {
        pointer: isPointer,
      })}
    >
      <LinkElement to={path} relative="path">
        <Text lKey={lKey} />
      </LinkElement>
    </div>
  );
};
